import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'linkify'
})
export class LinkifyPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(text: string): SafeHtml {
    if (!text) return text;

    // Regular expression to match URLs
    const urlRegex = /(https?:\/\/[^\s<>"{}|\\^`[\]]+)/gi;
    
    // Replace URLs with clickable links
    const linkedText = text.replace(urlRegex, (url) => {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="message-link">${url}</a>`;
    });

    // Also handle URLs that don't have http/https
    const wwwRegex = /(www\.[^\s<>"{}|\\^`[\]]+)/gi;
    const finalText = linkedText.replace(wwwRegex, (url) => {
      return `<a href="https://${url}" target="_blank" rel="noopener noreferrer" class="message-link">${url}</a>`;
    });

    return this.sanitizer.bypassSecurityTrustHtml(finalText);
  }
}
